export default function findByReferenceSlug(items, reference, slug) {
  if (!slug || !reference) {
    return undefined;
  }
  return items?.find((item) => item[reference].slug === slug);
}
